export const API_ENVIRONMENT_STORAGE_KEY = "sitehub_api_environment";

export const API_ENVIRONMENT_URLS = {
  development: "https://development.sitehubpro.com",
  staging: "https://staging.sitehubpro.com"
} as const;

export type ApiEnvironmentId = keyof typeof API_ENVIRONMENT_URLS;

const API_ENVIRONMENT_IDS = Object.keys(
  API_ENVIRONMENT_URLS
) as ApiEnvironmentId[];

export function isApiEnvironmentId(
  value: string | null
): value is ApiEnvironmentId {
  return API_ENVIRONMENT_IDS.some((id) => id === value);
}

export function readStoredApiEnvironment(): ApiEnvironmentId | null {
  if (typeof localStorage === "undefined") return null;
  const stored = localStorage.getItem(API_ENVIRONMENT_STORAGE_KEY);
  return isApiEnvironmentId(stored) ? stored : null;
}

export function currentApiEnvironmentId(): ApiEnvironmentId {
  return readStoredApiEnvironment() ?? "development";
}
